import React from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useGetAppointmentQuery } from "store";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Text,
    Box,
    Link as ChakraLink,
    Grid,
    GridItem,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Spinner,
    Center,
    Checkbox,
} from "@chakra-ui/react";
import moment from "moment";

const AppointmentDetail = () => {
    const { id } = useParams();
    const { data: appData, isLoading, error } = useGetAppointmentQuery(id);
    const navigate = useNavigate();

    const handleUpdateClick = () => {
        navigate(`/appointments/${id}/update`);
    };

    const day = moment(appData?.date, "YYYY,MM,DD").toDate();

    const formattedDay = day.toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });

    const time = appData?.time;
    const formattedTime = moment(time, "HH:mm:ss.SSSSSS").format("h:mm A");

    const SERVICE_CHOICES = {
        chk_up: "Check Up",
        fill: "Filling",
        ext: "Extraction",
        clean: "Cleaning",
        rct: "Root Canal Therapy",
        oth: "Other",
    };

    const DENT_CHOICES = {
        NONE: "No-Preference",
        ROSE: "Dr. Naale Morgan-Rose",
        ANDREW: "Andrew Williams",
    };

    if (isLoading) {
        return (
            <Center>
                <Spinner size="xl" />
            </Center>
        );
    }

    if (error) {
        return (
            <Text> Error fetching appointment details: {error.message}</Text>
        );
    }

    return (
        <Box mt={20} p={4}>
            <Card
                boxShadow="md"
                borderRadius="2xl"
                overflow="hidden"
                p={4}
                border="1px solid"
                borderColor="gray.300"
            >
                <CardHeader borderBottom="1px solid" borderColor="blue.200">
                    <Box textAlign="center" mb={4}>
                        <Text fontSize="2xl" fontWeight="bold">
                            {appData?.name} Details
                        </Text>
                    </Box>
                </CardHeader>

                <CardBody>
                    <Box
                        overflow="auto"
                        border="1px solid"
                        borderRadius="md"
                        borderColor="gray.300"
                    >
                        <Table
                            variant="striped"
                            colorScheme="blue"
                            size="md"
                            borderRadius="md"
                            overflow="hidden"
                        >
                            <Thead>
                                <Tr>
                                    <Th
                                        colSpan={11}
                                        bg="gray.200"
                                        textAlign="center"
                                        p={4}
                                        borderTopRadius="md"
                                    >
                                        <Text
                                            fontSize="2xl"
                                            fontFamily="Arial, sans-serif"
                                            fontWeight="bold"
                                        >
                                            DATA
                                        </Text>
                                    </Th>
                                </Tr>
                            </Thead>

                            <Tbody>
                                <Tr>
                                    <Td fontSize="md">
                                        <strong>Name</strong>
                                    </Td>
                                    <Td fontSize="md">{appData.name}</Td>
                                </Tr>
                                <Tr>
                                    <Td fontSize="md">
                                        <strong>Telephone</strong>
                                    </Td>
                                    <Td fontSize="md">{appData.phone}</Td>
                                </Tr>
                                <Tr>
                                    <Td fontSize="md">
                                        <strong>Address</strong>
                                    </Td>
                                    <Td fontSize="md">{appData.address}</Td>
                                </Tr>
                                <Tr>
                                    <Td fontSize="md">
                                        <strong>Date</strong>
                                    </Td>
                                    <Td fontSize="md">{formattedDay}</Td>
                                </Tr>
                                <Tr>
                                    <Td fontSize="md">
                                        <strong>Time</strong>
                                    </Td>
                                    <Td fontSize="md">{formattedTime}</Td>
                                </Tr>
                                <Tr>
                                    <Td fontSize="md">
                                        <strong>Dentist of Choice</strong>
                                    </Td>
                                    <Td fontSize="md">{DENT_CHOICES[appData.dent_choice] || "Unknown"}</Td>
                                </Tr>
                                <Tr>
                                    <Td fontSize="md">
                                        <strong>Service</strong>
                                    </Td>
                                    <Td fontSize="md">
                                        {SERVICE_CHOICES[appData.service_choice] ||
                                            "Unknown"}
                                    </Td>
                                </Tr>
                            </Tbody>
                        </Table>
                    </Box>
                </CardBody>

                <CardFooter p={4} borderTop="1px solid" borderColor="gray.300">
                    <Grid templateColumns="repeat(2, 1fr)" gap={4} width="100%">
                        <GridItem>
                            <ChakraLink
                                as={Link}
                                to="/appointments"
                                color="blue.500"
                            >
                                Back to List
                            </ChakraLink>
                        </GridItem>
                        <GridItem textAlign="right">
                            <Button
                                colorScheme="blue"
                                onClick={(e) => {
                                    handleUpdateClick();
                                    e.stopPropagation();
                                }}
                            >
                                Update
                            </Button>
                        </GridItem>
                    </Grid>
                </CardFooter>
            </Card>
        </Box>
    );
};

export default AppointmentDetail;
